<article class="extended-usp text-center" [attr.aria-labelledby]="uid()">
  <div class="extended-usp__icon">
    @if (icon(); as icon) {
      <crnt-icon [icon]="icon" size="4x" />
    }
  </div>
  @if (title(); as title) {
    <h3 *scText="title" class="extended-usp__title" [attr.id]="uid()"></h3>
  }
  @if (description(); as description) {
    <p *scText="description" class="extended-usp__description"></p>
  }
</article>
